import React from 'react';

import { Box, Card, Container, Grid } from '@mui/material';

import { SendRequestForm } from './send-request-form';
import { useSupportPageStyles } from './support-page-styles';
import { SupportNumberCard } from './support-number-card';
import { SupportEmailCard } from './support-email-card';

export type ContactSupportContainerProps = {
  showSupportNumber?: boolean;
  showSupportEmail?: boolean;
};

export const ContactSupportContainer: React.VFC<ContactSupportContainerProps> = ({ showSupportNumber = true, showSupportEmail = true }) => {
  const { classes } = useSupportPageStyles();

  return (
    <Container className={classes.container}>
      <Grid container className={classes.grid}>
        <Box className={classes.gridItem}>
          <Card className={classes.cardLeft}>
            <SendRequestForm />
          </Card>
        </Box>
        {(showSupportNumber || showSupportEmail) && (
          <Box className={classes.gridItem}>
            {showSupportNumber && <SupportNumberCard />}
            {showSupportEmail && <SupportEmailCard />}
          </Box>
        )}
      </Grid>
    </Container>
  );
};
